import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Dashboard = Loadable({
  loader: () => import("./routes/dashboard"),
  loading: TopBarProgress,
});

const Profile = Loadable({
  loader: () => import("./routes/profile"),
  loading: TopBarProgress,
});

const Routes = Loadable({
  loader: () => import("./routes/routes"),
  loading: TopBarProgress,
});
const National = Loadable({
  loader: () => import("./routes/national"),
  loading: TopBarProgress,
});
const LastMile = Loadable({
  loader: () => import("./routes/last-mile"),
  loading: TopBarProgress,
});

const ClientLead = () => (
  <Switch>
    <Route path="/dashboard">
      <Dashboard />
    </Route>
    <Route path="/profile">
      <Profile />
    </Route>
    <Route path="/routes">
      <Routes />
    </Route>
    <Route path="/national">
      <National />
    </Route>
    <Route path="/lastmile">
      <LastMile />
    </Route>
    <Redirect to="/dashboard" />
  </Switch>
);

export default ClientLead;
